import { Alert } from '@mui/material';
import React from 'react';

type RFC = React.FC<React.PropsWithChildren>;

export const DpAlert: RFC = ({ children, ...props }) => (
	<Alert severity="info" {...props}>
		{children}
	</Alert>
);
